import { isDevMode, Provider } from '@angular/core';
import { AuthenticationService, AuthorizationService } from '~ngx-shared/authentication';
import { LOGGER_CONFIG, LOGGER_CONTEXT, LoggerConfig } from '~ngx-shared/services';
import { environment } from '~shared/environment';
import { APP_VERSION } from '~shared/version';
import { OpenobserveRumService } from './openobserve-rum.service';

export function provideClientErrorLogging(app: string): Provider[] {
  return [
    {
      provide: LOGGER_CONFIG,
      useValue: {
        endpoint: `${environment.externalServiceUrl}/log/client`,
        app,
        appVersion: APP_VERSION,
        enabled: !isDevMode()
      } satisfies LoggerConfig
    },
    {
      // The endpoint is unauthenticated, so send only the identity the log uses, not every claim.
      provide: LOGGER_CONTEXT,
      useFactory:
        (
          authentication: AuthenticationService,
          authorization: AuthorizationService,
          rum: OpenobserveRumService
        ) =>
        () => {
          const claims = authentication.authStore.value?.['headers'] ?? {};
          const sessionId = rum.sessionId();
          let requestId: string | undefined;
          if (sessionId) {
            // RequestIdFilter logs it as mdc.requestId, which joins the line to the RUM session.
            requestId = `${sessionId}.log`;
          }
          return {
            'x-hasura-role': authorization.currentRole(),
            'x-hasura-user-id': claims['x-hasura-user-id'],
            'x-hasura-person-id': claims['x-hasura-person-id'],
            'x-request-id': requestId
          };
        },
      deps: [AuthenticationService, AuthorizationService, OpenobserveRumService]
    }
  ];
}
